var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"variant":_vm.variant},on:{"click":_vm.openPopup}},[_c('i',{staticClass:"fa fa-facebook fa-lg",class:_vm.customClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }